import { CommonModule } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { OrderManagementService } from '../../../Services/order-management.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { apiEndPoints } from '../../../api/apiEndPoint';
import {
  NgbModal,
  NgbModalModule,
  NgbOffcanvas,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { LoaderComponent } from '../../loader/loader.component';
import { HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MasterInformationService } from '../../../Services/master-information.service';
import { DashboardService } from '../../../Services/dashboard.service';
import { NoDataFoundComponent } from '../../no-data-found/no-data-found.component';

enum Status {
  Approve = 1,
  Repost = 2,
  Denied = 3,
}

@Component({
  selector: 'app-baldia-approval',
  standalone: true,
  imports: [
    CommonModule,
    ToastrModule,
    NgbPaginationModule,
    ReactiveFormsModule,
    NgbModalModule,
    FormsModule,
    LoaderComponent,
    NoDataFoundComponent,
  ],
  templateUrl: './baldia-approval.component.html',
  styleUrl: './baldia-approval.component.css',
})
export class BaldiaApprovalComponent implements OnInit {
  @ViewChild('confirmationModal') confirmationModal!: TemplateRef<any>;
  @ViewChild('pdfViewer', { static: true }) pdfViewer!: TemplateRef<any>;
  approveOrderList: any;
  currentPage: number = 1;
  pageSize: number = 5;
  selectedOrderId: any;
  orderForm: FormGroup;
  requestorName: any;
  selectedRequestorId: any;
  orderStatus: any;
  baldiaDumpyardList: any;
  selectedReqLat: any;
  selectedReqLng: any;
  dumpyardDistances: any;
  selectedDumpyard: any = null;
  selectedDumpyardId: any;
  selectedRequestorName: any;
  orderId: any;
  dumpyardId: any;
  baldiaOrderId: any;
  baldiaReqId: any;
  actionType: any;
  reasonText: any;
  reasonForm: FormGroup;
  selectedFile: any;
  additionalFile: any;
  isLoading: boolean = false;
  isDeny: boolean = false;
  selectedDumpyardDistance: any;
  cityId: any;
  userId: any;
  requestType: any;
  pdfDataUrl: any;
  fileType: any;
  imageDataUrl: any;
  pageSizeOptions = [5, 10, 20, 50];
  cityList: any;
  selectedCityId: any;
  selectedZoneId: any;
  zoneList: any;
  fromDate: any;
  ngFromDate: any;
  ngToDate: any;
  toDate: any;
  isToDateShow: boolean = false;
  selectedCity: string = '';
  selectedZone: string = '';

  constructor(
    private orderService: OrderManagementService,
    private toastService: ToastrService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private offcanvasService: NgbOffcanvas,
    private sanitizer: DomSanitizer,
    private masterService: MasterInformationService,
    private dashService: DashboardService
  ) {
    this.orderForm = this.fb.group({
      userType: ['', { disabled: true }],
      companyName: ['', { disabled: true }],
      mobileNumber: ['', { disabled: true }],
      location: ['', { disabled: true }],
      reqLat: ['', { disabled: true }],
      reqLng: ['', { disabled: true }],
      email: ['', { disabled: true }],
      city: ['', { disabled: true }],
      zone: ['', { disabled: true }],
      reqDate: ['', { disabled: true }],
      scheduledDate: ['', { disabled: true }],
      containerName: ['', { disabled: true }],
      containerCapacity: ['', { disabled: true }],
      containerCount: ['', { disabled: true }],
      rentalDuration: ['', { disabled: true }],
      totalTrip: ['', { disabled: true }],
      actualTrip: ['', { disabled: true }],
      sar: ['', { disabled: true }],
      material: [''],
      qty: [''],
      requestType: [''],
    });

    this.reasonForm = this.fb.group({
      reasonText: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getApproveOrder();
    this.getCity();
  }

  onPageChange(page: number): void {
    this.currentPage = page;
  }

  get pagedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.approveOrderList?.slice(start, end);
  }

  // -------------------------------- Get Approve Order List API -------------------------------- //

  getApproveOrder() {
    this.isLoading = true;
    this.orderService
      .getBaldiaApproveOrderList(
        apiEndPoints.getApproveOrder,
        this.selectedCityId,
        this.selectedZoneId,
        this.fromDate,
        this.toDate
      )
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;

          const details = response?.body?.details;

          if (Array.isArray(details)) {
            this.approveOrderList = details.filter(
              (detail: any) => detail.requesterStatusCode == 100
            );
          } else {
            this.approveOrderList = [];
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.toastService.error(
            'An unexpected error occurred in getting list. Please try again later.',
            'Error',
            {
              timeOut: 1000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
          this.approveOrderList = [];
        },
      });
  }

  // -------------------------------- Get Dumpyard List API -------------------------------- //

  getDumpyardList() {
    this.isLoading = true;
    this.orderService
      .getDumpyardList(apiEndPoints.baldiaDumpyardList)
      .subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            const allDumpyards = response.body.details;
            this.baldiaDumpyardList = allDumpyards.filter(
              (data: any) => data.cityId == this.cityId
            );

            console.log('Filtered dumpyards:', this.baldiaDumpyardList);
            this.calculateDistances();
          }

          this.isLoading = false;
        },

        error: (error) => {
          this.toastService.error(
            'Error getting dumpyard list. Please try again later.',
            'Error',
            {
              timeOut: 1000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
          this.isLoading = false;
        },
      });
  }

  // ----------------------------------- Get All City List API ----------------------------------- //

  getCity() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        this.cityList = response.body?.details;
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // ----------------------------------- City Change Dropdown ----------------------------------- //

  onCityChange(event: Event) {
    const selectedCity = (event.target as HTMLSelectElement).value;
    this.selectedCityId = selectedCity;
    this.currentPage = 1;
    this.getApproveOrder();
    this.getZone();
  }

  // ----------------------------------- Get All Zone List API ----------------------------------- //

  getZone() {
    this.dashService
      .getZoneList(apiEndPoints.zoneList, this.selectedCityId)
      .subscribe({
        next: (response: any) => {
          this.zoneList = response.body.details;
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  // ----------------------------------- Zone Change Dropdown ----------------------------------- //

  onZoneChange(event: Event) {
    const selectedZoneId = (event.target as HTMLSelectElement).value;
    this.selectedZoneId = selectedZoneId;
    this.getApproveOrder();
  }

  // -------------------------------- View Details By Order ID -------------------------------- //

  openDetailModal(modal: any, row: any) {
    this.selectedDumpyardId = null;
    this.dumpyardId = null;
    this.selectedDumpyardDistance = null;
    this.cityId = row.cityId;
    this.getDumpyardList();
    this.orderId = row.orderId;
    this.userId = row.requestorId;
    this.requestType = row.requesttype;
    this.selectedRequestorName = row.requestorName;
    this.selectedReqLat = row.requestorLatitude;
    this.selectedReqLng = row.requestorLongitude;

    this.selectedOrderId = row.orderId;
    this.baldiaOrderId = this.selectedOrderId;
    this.baldiaReqId = row.requestorId;

    const formatDate = (date: string | null): string => {
      if (!date) return '';
      const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      };
      return new Intl.DateTimeFormat('en-GB', options).format(new Date(date));
    };

    const formattedReqDate = formatDate(row.requestDate);
    const formattedScheduledDate = formatDate(row.scheduledDate);

    // Patch the response data into the form
    this.orderForm.patchValue({
      userType: row.requestorType || '',
      companyName:
        row.requestorType == 'Individual Requester'
          ? row.requestorName
          : row.companyName || '',
      mobileNumber: row.requestorMobile || '',
      location: row.resquestorLocation || '',
      reqLat: row.requestorLatitude || '',
      reqLng: row.requestorLongitude || '',
      email: '',
      city: row.city || '',
      zone: row.zone || '',
      reqDate: formattedReqDate,
      scheduledDate: formattedScheduledDate,
      containerName: row.containerName || '',
      containerCapacity: row.containerCapacity || '',
      containerCount: row.containerCount || '',
      rentalDuration: row.rentalDuration || '',
      totalTrip: row.noOfTotalTrips || 0,
      actualTrip: row.noOfActualTrips || 0,
      sar: row.sar || '',
      material: row.mainMaterialName,
      qty: row.materialQty,
      requestType: row.requesttype,
    });

    this.calculateDistances();

    this.modalService.open(modal, {
      ariaLabelledBy: 'confirmation-modal-title',
      size: 'lg',
    });
  }

  calculateDistances() {
    if (this.baldiaDumpyardList && this.baldiaDumpyardList.length > 0) {
      this.dumpyardDistances = this.baldiaDumpyardList.map((dumpyard: any) => {
        const distance = this.calculateDistance(
          this.selectedReqLat,
          this.selectedReqLng,
          dumpyard.latitude,
          dumpyard.longitude
        );
        return {
          ...dumpyard,
          distance: distance.toFixed(2),
        };
      });
    } else {
      this.dumpyardDistances = [];
    }
  }

  calculateDistance(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number
  ): number {
    const toRad = (value: number) => (value * Math.PI) / 180;

    const R = 6371; // Earth's radius in KM
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distance in KM
  }

  // -------------------------------- Confirmation Modal -------------------------------- //

  openConfirmationModal(row: any): void {
    if (this.dumpyardId == null) {
      this.toastService.info('Select the dumpyard.', 'Info', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
        progressBar: true,
      });
      return;
    }

    this.selectedOrderId = row.orderId;
    this.requestorName = row.requestorName;
    this.selectedRequestorId = row.requestorId;
    this.orderStatus = row.currentOrderStatus;
    this.modalService.open(this.confirmationModal, {
      ariaLabelledBy: 'confirmation-modal-title',
    });
  }

  // -------------------------------- Post Approve Order Status API -------------------------------- //

  approveOrder(type: any) {
    this.isLoading = true;
    const roundedDumpyardDistance = parseFloat(
      this.selectedDumpyardDistance
    ).toFixed(2);

    const queryParams = {
      OrderId: this.baldiaOrderId,
      RequestorUserId: this.baldiaReqId,
      DumpyardUserId: this.dumpyardId,
      BaldiaApproval: Status.Approve,
      DumpyardDistance: roundedDumpyardDistance,
    };
    const formData = new FormData();

    if (type === 'Approve') {
      queryParams.BaldiaApproval = Status.Approve;
    } else if (type === 'deny') {
      queryParams.BaldiaApproval = Status.Denied;
      formData.append('RejectReason', this.reasonForm.value.reasonText);
    } else if (type === 'resubmit') {
      queryParams.BaldiaApproval = Status.Repost;
      formData.append('RejectReason', this.reasonForm.value.reasonText);
    }

    if (this.selectedFile) {
      formData.append('BaldiaDoc', this.selectedFile);
    }

    this.orderService
      .postBaldiaApprove(apiEndPoints.baldiaApprove, queryParams, formData)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          if (response.isSuccess) {
            this.modalService.dismissAll();

            let message = '';
            switch (queryParams.BaldiaApproval) {
              case Status.Approve:
                message = 'Order Approved Successfully';
                break;
              case Status.Denied:
                message = 'Order Denied Successfully';
                break;
              case Status.Repost:
                message = 'Order Resubmitted Successfully';
                break;
              default:
                message = 'Action Completed Successfully';
            }

            this.toastr.success(message, 'Success', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            });

            this.getApproveOrder();
          } else {
            this.toastService.error(
              'Unable to approve the order. Please try again later.',
              'Error',
              {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true,
              }
            );
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.toastService.error(
            'Error in approving order. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  onCheckboxChange(dump: any, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.dumpyardId = dump.dumpyardId;
    this.selectedDumpyardDistance = dump.distance;

    if (isChecked) {
      this.selectedDumpyardId = dump.dumpyardId;
    } else {
      this.selectedDumpyardId = null;
    }
  }

  openReasonModal(content: any, action: string) {
    this.reasonForm.reset();
    if (action == 'deny') {
      this.isDeny = true;
    } else {
      this.isDeny = false;
    }
    this.actionType = action;
    this.reasonText = '';
    this.modalService.open(content, { backdrop: 'static' });
  }

  submitReason(modal: any) {
    console.log(`Action: ${this.actionType}`);
    console.log(`Reason: ${this.reasonText}`);

    // Based on actionType, you can call different APIs or functions
    if (this.actionType === 'deny') {
      // call deny function
    } else if (this.actionType === 'resubmit') {
      // call resubmit function
    }

    modal.close();
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.selectedFile = file;
    }
  }
  onAdditionalFileSelected(event: any) {
    this.additionalFile = event.target.files[0];
  }

  // -------------------------------- Download EOC API -------------------------------- //
  downloadEocDoc() {
    this.isLoading = true;

    this.orderService
      .getBaldiaDoc(apiEndPoints.baldiaDoc, this.orderId)
      .subscribe({
        next: (response: HttpResponse<Blob>) => {
          this.isLoading = false;

          const contentDisposition = response.headers.get(
            'Content-Disposition'
          );
          let filename = this.extractFileName(contentDisposition);

          const rawContentType = response.headers.get('Content-Type') || '';
          const cleanedContentType = this.normalizeMimeType(rawContentType);

          // If filename is missing, create a fallback
          if (!filename) {
            const extension = this.getExtensionFromMime(cleanedContentType);
            filename = `user-${this.userId || 'unknown'}.${extension}`;
          } else {
            // If filename doesn't contain a proper extension, add one
            const extMatch = filename.match(/\.[a-zA-Z0-9]+$/);
            if (!extMatch) {
              const extension = this.getExtensionFromMime(cleanedContentType);
              filename += `.${extension}`;
            }
          }

          if (response.body) {
            const extFromFilename = filename.split('.').pop() || '';
            const finalMimeType =
              cleanedContentType === 'application/octet-stream'
                ? this.getMimeFromExtension(extFromFilename)
                : cleanedContentType;

            const blob = new Blob([response.body], { type: finalMimeType });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url);

            this.toastr.success('File downloaded successfully', 'Success', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          } else {
            this.toastr.error('File content is empty', 'Error', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }
        },
        error: () => {
          this.isLoading = false;
          this.toastr.info('No file found.', 'Info', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          });
        },
      });
  }

  private extractFileName(contentDisposition: string | null): string | null {
    if (!contentDisposition) return null;
    const match = contentDisposition.match(
      /filename\*?=(?:UTF-8'')?["']?([^;"']+)/i
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  private normalizeMimeType(contentType: string): string {
    if (contentType === 'application/.pdf' || contentType === '.pdf')
      return 'application/pdf';
    if (contentType === 'application/.jpg' || contentType === '.jpg')
      return 'image/jpeg';
    if (contentType === 'application/.jpeg' || contentType === '.jpeg')
      return 'image/jpeg';
    if (contentType === 'application/.png' || contentType === '.png')
      return 'image/png';
    return contentType.replace('/.', '/');
  }

  private getExtensionFromMime(contentType: string): string {
    const mimeMap: { [key: string]: string } = {
      'application/pdf': 'pdf',
      'image/jpeg': 'jpg',
      'image/jpg': 'jpg',
      'image/png': 'png',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        'xlsx',
      'application/msword': 'doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        'docx',
    };
    return mimeMap[contentType] || 'pdf';
  }

  private getMimeFromExtension(extension: string): string {
    const extMap: { [key: string]: string } = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      doc: 'application/msword',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    };
    return extMap[extension.toLowerCase()] || 'application/octet-stream';
  }

  // -------------------------------- View EOC API -------------------------------- //

  viewEoc() {
    console.log('hiiii');
    this.orderService
      .getEocDoc(apiEndPoints.viewEoc, this.orderId)
      .subscribe((res) => {
        if (res?.body?.details) {
          console.log('Response received');
          const base64 = res.body.details;
          const mimeType = res.body.filetype;

          if (mimeType) {
            console.log('MIME Type:', mimeType);
            this.fileType = mimeType;
            const unsafeUrl = `data:${mimeType};base64,${base64}`;

            if (mimeType.includes('pdf')) {
              this.pdfDataUrl =
                this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
              this.imageDataUrl = null;
            } else if (mimeType.includes('image')) {
              this.imageDataUrl =
                this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
              this.pdfDataUrl = null;
            } else {
              console.error('Unknown file type:', mimeType);
            }
            this.openOffcanvas();
          } else {
            console.error('MIME Type is undefined');
          }
        }
      });
  }

  openOffcanvas() {
    console.log('openOffcanvas called');
    if (this.pdfDataUrl || this.imageDataUrl) {
      this.offcanvasService.open(this.pdfViewer, {
        position: 'end',
        backdrop: true,
        panelClass: 'custom-offcanvas-on-top',
      });
    } else {
      console.error('No PDF or Image URL to display.');
    }
  }

  onFromDateChange(event: any) {
    this.fromDate = event.target.value;
    this.ngFromDate = this.fromDate;

    this.ngToDate = '';
    this.toDate = '';
    this.isToDateShow = true;

    this.getApproveOrder();
  }

  clearGrid() {
    this.selectedCity = '';
    this.selectedZone = '';
    this.fromDate = '';
    this.ngFromDate = '';
    this.selectedCityId = '';
    this.selectedZoneId = '';
    this.getApproveOrder();
  }

  // onToDateChange(event: any) {
  //   this.toDate = event.target.value;

  //   if (new Date(this.toDate) < new Date(this.fromDate)) {
  //     this.toastr.info('To Date cannot be before From Date!', 'Info', {
  //       timeOut: 3000,
  //       positionClass: 'toast-top-right',
  //       progressBar: true,
  //     });
  //     this.ngToDate = '';
  //     this.toDate = '';
  //     return;
  //   }

  //   this.ngToDate = this.toDate;

  //   this.getApproveOrder();
  // }
}
